<section class="roi-section" id="roi">
  <div class="container">
    <div class="roi-content">
      <span class="section-badge" style="background: rgba(212, 165, 116, 0.2); border-color: rgba(212, 165, 116, 0.3); color: var(--gold-light);">Impact financier</span>
      <h2>Revenus générés la première année</h2>
      <p>Un cabinet moyen (100 clients) génère 45 000€ de revenus additionnels dès la première année avec Wealthlane.</p>
      <div class="roi-stats">
        <div class="roi-stat">
          <div class="roi-stat-value">2-8k€</div>
          <div class="roi-stat-label">Par mission patrimoniale</div>
          <div class="roi-stat-detail">vs 500-1500€ en comptabilité classique</div>
        </div>
        <div class="roi-stat">
          <div class="roi-stat-value">15-20</div>
          <div class="roi-stat-label">Missions/an réalistes</div>
          <div class="roi-stat-detail">Sur votre portefeuille actuel</div>
        </div>
        <div class="roi-stat">
          <div class="roi-stat-value">45k€</div>
          <div class="roi-stat-label">Revenus additionnels</div>
          <div class="roi-stat-detail">Année 1, sans nouveau client</div>
        </div>
        <div class="roi-stat">
          <div class="roi-stat-value">+1%</div>
          <div class="roi-stat-label">Commission produits</div>
          <div class="roi-stat-detail">Sur chaque souscription réalisée</div>
        </div>
      </div>
      <a  class="hero-btn-primary" (click)="openROIPopupEvent.emit()"><span>Calculer mes revenus</span></a>
    </div>
  </div>
</section>

